/** 余额 / 充值 / 流水 (公司管理员) */
import { apiFetch } from "@/lib/api-client";

export type RechargeStatus = "pending" | "paid" | "failed";

export interface RechargeOrder {
  merchant_order_no: string;
  status: RechargeStatus;
  amount_fen: number;
  /** 后端格式化好的 "10.00" */
  amount_yuan: string;
  credits_fen: number;
  out_trade_no: string | null;
  code_url: string | null;
  created_at: string;
  paid_at: string | null;
}

export interface RechargeCreateResponse extends RechargeOrder {
  success: boolean;
  pay_channel_ready: boolean;
}

export interface RechargeStatusResponse extends RechargeOrder {
  success: boolean;
  balance_fen: number;
}

export type LedgerReason = "recharge" | "quote" | "image" | "adjust";

export interface LedgerEntry {
  id: number;
  company_id: number;
  delta_fen: number;
  balance_after: number;
  reason: LedgerReason | string;
  ref: string | null;
  user_id: number | null;
  created_at: string;
}

export interface LedgerResponse {
  success: boolean;
  balance_fen: number;
  total: number;
  data: LedgerEntry[];
}

export async function createRecharge(amount_yuan: number) {
  return apiFetch<RechargeCreateResponse>("/api/recharge/create", {
    method: "POST",
    body: JSON.stringify({ amount_yuan }),
  });
}

export async function getRecharge(no: string) {
  return apiFetch<RechargeStatusResponse>(`/api/recharge/${encodeURIComponent(no)}`);
}

export async function listRecharges(limit = 50) {
  return apiFetch<{ success: boolean; data: RechargeOrder[] }>(`/api/recharge?limit=${limit}`);
}

export async function getLedger(limit = 50, offset = 0) {
  return apiFetch<LedgerResponse>(`/api/credits/ledger?limit=${limit}&offset=${offset}`);
}
